import React, { useState } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { Eye, EyeOff } from "lucide-react"; // Lucide icons
import { changePasswoard } from "../../services/Auth/AuthService";
import { useNavigate } from "react-router-dom";
 
function ChangePassword({ password, onHide }) {
    // Error object for validation
    let errorsObj = { oldPassword: "", newPassword: "", confirmPassword: "" };
    const [errors, setErrors] = useState(errorsObj);
    const [apiError, setApiError] = useState();
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    // Password field visibility states
    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
 
    // Notifications
    const notifyTopRight = () => {
        toast.success(" Password Updated successfully !", {
            position: "top-right",
        });
    };
    const notifyError = (error) => {
        toast.error(`❌${error}`, { position: "top-right" });
    };
 
    // Password validation helper
    const validatePassword = (pwd) => {
        // Minimum eight characters, at least one uppercase, one lowercase, one number, one special character
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(pwd);
    };
 const navigate=useNavigate()
    function onChangePassword(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
 
        if (!oldPassword) {
            errorObj.oldPassword = "Old Password is required.";
            error = true;
        }
        if (!newPassword) {
            errorObj.newPassword = "New Password is required.";
            error = true;
        }  
        if (!confirmPassword) {
            errorObj.confirmPassword = "Confirm Password is required.";
            error = true;
        }
        if (oldPassword === newPassword && oldPassword !== "") {
            errorObj.newPassword = "Please create a new password.";
            error = true;
        }
        if (newPassword !== confirmPassword) {
            errorObj.confirmPassword = "Passwords do not match.";
            error = true;
        }
        setErrors(errorObj);
        if (error) return;
 
        changePasswoard(oldPassword, newPassword)
            .then(() => {
                setOldPassword("");
                setNewPassword("");
                setConfirmPassword("");
                onHide();
                notifyTopRight();
             setTimeout(() => {
    localStorage.removeItem("bzybeToken"); // correct method
    navigate("/login");
}, 1500);
            })
            .catch((error) => {
                notifyError(
                    error?.response?.data?.message || "Error updating password"
                );
            });
    }
       const handleCancel = () => {
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setErrors(errorsObj);
        setApiError("");
        onHide(); // close modal
    };




    return (
        <>
            <ToastContainer
                position="top-left"
                autoClose={5000}
            />
            <Modal
                className="modal fade"
                show={password}
                centered
            >
                <div role="document">
                    <div>
                        <form onSubmit={onChangePassword}>
                            <div className="modal-header">
                                <h4 className="modal-title fs-20">
                                    Change Password
                                </h4>
                            </div>
                            <div className="modal-body">
                                {apiError && (
                                    <div
                                        role="alert"
                                        className="alert alert-danger show"
                                    >
                                        {apiError}
                                    </div>
                                )}
 
                                {/* Old Password Input */}
                                <div className="form-group mb-3">
                                    <label className="text-black font-w500">
                                        Old Password
                                    </label>
                                    <div style={{ position: "relative" }}>
                                        <input
                                            type={showOld ? "text" : "password"}
                                            className="form-control"
                                            autoComplete="off"
                                            value={oldPassword}
                                            onChange={(e) =>
                                                setOldPassword(e.target.value)
                                            }
                                            placeholder="Enter your old password "
                                        />
                                        <span
                                            onClick={() =>
                                                setShowOld((v) => !v)
                                            }
                                            style={{
                                                position: "absolute",
                                                right: 10,
                                                top: 8,
                                                cursor: "pointer",
                                            }}
                                        >
                                            {showOld ? (
                                                <Eye size={20} />
                                            ) : (
                                                <EyeOff size={20} />
                                            )}
                                        </span>
                                    </div>
                                    {errors.oldPassword && (
                                        <div className="text-danger fs-12">
                                            {errors.oldPassword}
                                        </div>
                                    )}
                                </div>
 
                                {/* New Password Input */}
                                <div className="form-group mb-3">
                                    <label className="text-black font-w500">
                                        New Password
                                    </label>
                                    <div style={{ position: "relative" }}>
                                        <input
                                            type={showNew ? "text" : "password"}
                                            className="form-control"
                                            autoComplete="off"
                                            value={newPassword}
                                            onChange={(e) =>
                                                setNewPassword(e.target.value)
                                            }
                                            placeholder="Enter new password"
                                        />
                                        <span
                                            onClick={() =>
                                                setShowNew((v) => !v)
                                            }
                                            style={{
                                                position: "absolute",
                                                right: 10,
                                                top: 8,
                                                cursor: "pointer",
                                            }}
                                        >
                                            {showNew ? (
                                                <Eye size={20} />
                                            ) : (
                                                <EyeOff size={20} />
                                            )}
                                        </span>
                                    </div>
                                    {errors.newPassword && (
                                        <div className="text-danger fs-12">
                                            {errors.newPassword}
                                        </div>
                                    )}
                                </div>
 
                                {/* Confirm New Password Input */}
                                <div className="form-group mb-3">
                                    <label className="text-black font-w500">
                                        Confirm New Password
                                    </label>
                                    <div style={{ position: "relative" }}>
                                        <input
                                            type={
                                                showConfirm
                                                    ? "text"
                                                    : "password"
                                            }
                                            className="form-control"
                                            autoComplete="off"
                                            value={confirmPassword}
                                            onChange={(e) =>
                                                setConfirmPassword(
                                                    e.target.value
                                                )
                                            }
                                            placeholder="Re-enter new password"
                                        />
                                        <span
                                            onClick={() =>
                                                setShowConfirm((v) => !v)
                                            }
                                            style={{
                                                position: "absolute",
                                                right: 10,
                                                top: 8,
                                                cursor: "pointer",
                                            }}
                                        >
                                            {showConfirm ? (
                                                <Eye size={20} />
                                            ) : (
                                                <EyeOff size={20} />
                                            )}
                                        </span>
                                    </div>
                                    {errors.confirmPassword && (
                                        <div className="text-danger fs-12">
                                            {errors.confirmPassword}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="submit"
                                    style={{background:"#87C55F" ,color:"white"}}
                                    className="btn  "
                                >
                                    Submit
                                </button>
                                <button
                                    type="button"
                                    onClick={handleCancel}
                                    className="btn btn-danger"
                                >
                                    <i className="flaticon-delete-1"></i> Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </>
    );
}
 
const mapStateToProps = (state) => ({
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
});
 
export default connect(mapStateToProps)(ChangePassword);